/**
 * IoT 模块枚举定义
 * 
 * @generated 2025-12-06
 */

/** 设备在线状态 */
export enum DeviceOnlineStatus {
  /** 离线 */
  OFFLINE = 0,
  /** 在线 */
  ONLINE = 1
}

/** 设备运行状态 */
export enum DeviceStatus {
  /** 离线 */
  OFFLINE = 'offline',
  /** 空闲 */
  IDLE = 'idle',
  /** 运行中 */
  RUNNING = 'running',
  /** 报警 */
  ALARM = 'alarm'
}

/** 设备运行状态码 */
export enum DeviceStatusCode {
  /** 离线 */
  OFFLINE = 0,
  /** 空闲 */
  IDLE = 1,
  /** 运行中 */
  RUNNING = 2,
  /** 报警 */
  ALARM = 3
}

/** 设备类型 */
export enum DeviceType {
  /** 数控机床 */
  CNC = 'cnc',
  /** PLC */
  PLC = 'plc',
  /** 传感器 */
  SENSOR = 'sensor',
  /** 机器人 */
  ROBOT = 'robot'
}

/** 协议类型 */
export enum Protocol {
  /** NC-Link */
  NCLINK = 'nclink',
  /** OPC-UA */
  OPCUA = 'opcua',
  /** Modbus */
  MODBUS = 'modbus',
  /** MTConnect */
  MTCONNECT = 'mtconnect'
}

/** 报警级别 */
export enum AlarmLevel {
  /** 提示 */
  INFO = 1,
  /** 警告 */
  WARNING = 2,
  /** 错误 */
  ERROR = 3,
  /** 严重 */
  CRITICAL = 4
}

/** 报警状态 */
export enum AlarmStatus {
  /** 活动 */
  ACTIVE = 1,
  /** 已确认 */
  ACKNOWLEDGED = 2,
  /** 已清除 */
  CLEARED = 3
}

/** 厂家状态 */
export enum VendorStatus {
  /** 禁用 */
  DISABLED = 0,
  /** 启用 */
  ENABLED = 1
}
